var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgGotoConnectIcon = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 40,
  height: 40,
  fill: "none"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "#07CB73",
  fillRule: "evenodd",
  d: "M38 35 3.5 38.5 2 28.304 36.579 25z",
  clipRule: "evenodd"
})), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
  fill: "#000",
  d: "M34 20.245V28h-4.717v-5.211S27.044 28 18.809 28c-5.517 0-8.595-2.79-9.954-4.555a14.3 14.3 0 0 1-2.358-4.76 13.9 13.9 0 0 1-.12-6.893 13.75 13.75 0 0 1 4.797-7.796 13.7 13.7 0 0 1 3.838-2.175c2.2-.816 4.57-1.029 6.875-.616a13.05 13.05 0 0 1 6.676 3.283l.64.575-3.358 3.446-.36-.328a8.77 8.77 0 0 0-4.952-2.224 8.7 8.7 0 0 0-5.29 1.137 9.02 9.02 0 0 0-3.667 4.077 9.33 9.33 0 0 0-.682 5.504 8.8 8.8 0 0 0 1.556 3.675 8.5 8.5 0 0 0 3.001 2.562c1.44.82 3.798.862 5.437.615 5.437-.861 6.476-6.196 6.476-6.196h-7.595V12.49H34z"
})));
export { SvgGotoConnectIcon as ReactComponent };
export default __webpack_public_path__ + "img/goto-connect-icon.68eea480cae23f9822156e26e6c22ac2.svg";